export const UPDATE_SELECT_ROW_TAG = 'UPDATE_SELECT_ROW_TAG'
export const UPDATE_PAGINATION = 'UPDATE_PAGINATION'
export const UPDATE_TAG_LIST = 'UPDATE_TAG_LIST'
export const UPDATE_TAG_LOADING = 'UPDATE_TAG_LOADING'